import script from "./TableViewShareModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableViewShareModal.vue?vue&type=script&setup=true&lang=ts"

import "./TableViewShareModal.vue?vue&type=style&index=0&id=6b7a31e3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b7a31e3"]])

export default __exports__